export const STATE_NAME = 'appSettings';
